import { Component } from "@angular/core"

@Component({ styleUrls: ["index.scss"], templateUrl: "index.html" })
export class RouteWildcardComponent {
  errorCode: number = 404
}
